import React from 'react';
import type { ScoringStatus } from '../../types';

const STATUS_DOT: Record<ScoringStatus, string> = {
  PENDING: 'bg-slate-500 dark:bg-slate-400',
  PROCESSING: 'bg-primary animate-pulse',
  SCORED: 'bg-secondary',
  FLAGGED: 'bg-error animate-pulse',
  FAILED: 'bg-error',
};

interface ScoringStatusChipProps {
  status: ScoringStatus;
  /** Optional label override — used to show processing stage (e.g. "Compliance Check", "Scoring") */
  label?: string;
  className?: string;
}

const ScoringStatusChip: React.FC<ScoringStatusChipProps> = ({ status, label, className = '' }) => (
  <span className={`inline-flex items-center gap-2 text-slate-500 dark:text-slate-400 uppercase text-[10px] tracking-[0.1em] font-label ${className}`}>
    <span className={`w-1.5 h-1.5 rounded-full ${STATUS_DOT[status]}`} />
    {label ?? status}
  </span>
);

export default ScoringStatusChip;
